
const Allcoursereducer = ( state ,action )=>{
switch(action.type){
    case "SET_LOADING":
        return{
            ...state,
            loading:true,
        }
    case 'SET ALL COURSE DATA':
        return{
            ...state, 
            real_course : action.payload,
            Allcourse:[...action.payload],
            all_product : [...action.payload],   
            loading:false,
        }


        case 'SET GRID_VIEW': 
        return{
             ...state ,
             grid_view : true,
        }
        case 'SET LIST_VIEW':
            return{
                ...state , 
                grid_view: false,
            }
            
        case "GET_SINGLE_COURSE":
            return{
                ...state,
                singleCourse : action.payload ? [action.payload] : []
            };

            case 'UPDATE_FILTER_VALUE':
                const { name , value } = action.payload;
            
                if (name === 'categoryname'){
                    let updatedCategories = [...state.filters.categoryname];
                     console.log("updatedCategories",updatedCategories)
                    if (updatedCategories.includes(value)){
                        updatedCategories = updatedCategories.filter((item) => item !== value);
                    } else {
                        updatedCategories.push(value);
                    }
                     console.log("updatedCategories",updatedCategories)
                    return {
                        ...state,
                        filters: {
                            ...state.filters,
                            categoryname: updatedCategories, 
                        },
                    };
                }

                if(name === 'instructor'){
                    let updateinstructer = [...state.filters.instructor];
                    if(updateinstructer.includes(value)){
                        updateinstructer = updateinstructer.filter((item)=>item !== value);
                    }
                    else{
                        updateinstructer.push(value);
                    }
                    return{
                        ...state,
                        filters :{
                            ...state.filters,
                            instructor : updateinstructer,
                        }
                    }
                }


                if(name === 'price'){
                    let updateprice = [...state.filters.price];
                    if(updateprice.includes(value)){
                        updateprice = updateprice.filter((item)=>item !==value);
                    }

                    else{
                        updateprice.push(value);
                    }
                    return{
                        ...state,
                        filters:{
                            ...state.filters,
                            price:updateprice,
                        }
                    }
                }
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        [name]: value,
                    },
                };

            case "FILTER_PRODUCTS":
                let {all_product} = state;
                let tempFilterproduct = [...all_product];
                const {text , categoryname, price , instructor} = state.filters;

                if(text){
                    tempFilterproduct = tempFilterproduct.filter((curElm)=>{
                        return curElm.CourseMaster_title.toLowerCase().includes(text);                        
                    })
                }
                
                if(categoryname && categoryname.length > 0){
                    tempFilterproduct = tempFilterproduct.filter
                    ((curelm)=>categoryname.includes(curelm.CourseMaster_courseCat.category_name)
                  );
               }
                if(instructor && instructor.length > 0){
                    tempFilterproduct = tempFilterproduct.filter((cuitem)=>instructor.includes(cuitem.CourseMaster_Courseinstructor.CourseInstructor_name));
                }

            if(price.length > 0){
                 tempFilterproduct = tempFilterproduct.filter((curElm)=>{

             if(price.includes("free") && price.includes("paid")) {
                return true;
            }
            // Filter for free courses
            else if(price.includes("free")) {
                return curElm.CourseMaster_fee ==0;
            }
            // Filter for paid courses
            else if(price.includes("paid")){
                return curElm.CourseMaster_fee > 0;
            }
            return false;
                 });
               }

                return {
                    ...state,
                    Allcourse : tempFilterproduct, 
                }

                case 'SET_INSTRUCTER_DATA':
                    return{
                        ...state,
                        instructer_detail : action.payload,
                    }
               case 'GET_SINGLE_INSTRUCTER':
                return{
                    ...state,
                    single_instructer :  action.payload ? [action.payload] : [],
                    
                }
        default : 
        return state;
        
}
 

}
export default Allcoursereducer;